import { createContext, useContext, useEffect, useState } from "react";
import { api, formatApiErrorDetail } from "../lib/api";

const ContractorAuthContext = createContext(null);

export function ContractorAuthProvider({ children }) {
  const [data, setData] = useState(null); // null=checking, false=guest, obj=portal payload

  const refresh = async () => {
    try {
      const res = await api.get("/contractor/me");
      setData(res.data);
      return res.data;
    } catch (_) {
      setData(false);
      return null;
    }
  };

  useEffect(() => { refresh(); }, []);

  const login = async (email, password) => {
    try {
      const { data: d } = await api.post("/contractor-auth/login", { email, password });
      setData(d);
      return { ok: true };
    } catch (e) {
      return { ok: false, error: formatApiErrorDetail(e.response?.data?.detail) || e.message };
    }
  };

  const register = async (payload) => {
    try {
      const { data: d } = await api.post("/contractor-auth/register", payload);
      setData(d);
      return { ok: true };
    } catch (e) {
      return { ok: false, error: formatApiErrorDetail(e.response?.data?.detail) || e.message };
    }
  };

  const logout = async () => {
    try { await api.post("/contractor-auth/logout"); } catch (_) {}
    setData(false);
  };

  return (
    <ContractorAuthContext.Provider value={{ data, setData, login, register, logout, refresh }}>
      {children}
    </ContractorAuthContext.Provider>
  );
}

export const useContractorAuth = () => useContext(ContractorAuthContext);
